import type { ServiceLeadServiceType } from '@/data/service-quote-funnels'
import type { DiagnosisIdentification } from '@/lib/types/diagnosis'

// CJ Affiliate (Commission Junction) tracking for the Angi advertiser
// (7439025). Property: "What Grass Is This? Lawn Care Tools & Guides"
// (PID 101814843). Click URLs follow https://www.tkqlhce.com/click-<PID>-<linkId>
// and land on Angi's service-request funnel for the mapped category; commissions
// pay per completed service request. Link IDs pulled from the CJ links list
// 2026-07-18 — only three Angi categories map cleanly onto our service types.
const CJ_PID = '101814843'

const ANGI_LINK_IDS: Record<ServiceLeadServiceType, string> = {
  // Angi "Lawn & Garden Care" (17142834)
  lawn_care: '17142834',
  weed_control: '17142834',
  sprinkler_repair: '17142834',
  landscaping: '17142834',
  tree_removal: '17142834',
  sod_installation: '17142834',
  aeration_overseeding: '17142834',
  mulch_installation: '17142834',
  // Angi "Pest Control Services" (17141195)
  pest_control: '17141195',
  mosquito_control: '17141195',
  // Angi "Electrical" (17142831)
  outdoor_lighting: '17142831',
}

/**
 * Diagnose problem category -> Angi service. Pests get Angi's dedicated Pest
 * Control funnel; everything else lands on Lawn & Garden Care (there is no
 * disease/nutrient-specific Angi category).
 */
export const DIAGNOSIS_TYPE_TO_SERVICE: Record<
  DiagnosisIdentification['type'],
  ServiceLeadServiceType
> = {
  pest: 'pest_control',
  disease: 'lawn_care',
  weed: 'weed_control',
  nutrient_deficiency: 'lawn_care',
  environmental: 'lawn_care',
}

/**
 * Tracked Angi click URL for a service type. `sid` is CJ's per-click
 * sub-ID (shows up in commission reports) — pass the placement so we can
 * attribute earnings per surface. Keep sids short and PII-free.
 */
export function getAngiAffiliateUrl(serviceType: ServiceLeadServiceType, sid?: string): string {
  const base = `https://www.tkqlhce.com/click-${CJ_PID}-${ANGI_LINK_IDS[serviceType]}`
  return sid ? `${base}?sid=${encodeURIComponent(sid.slice(0, 60))}` : base
}
